import { expansionPanelItem }from './expansionPanel';


export const webFrameworksDetailSectionItems: expansionPanelItem[] = [
  {
    title: 'Laravel',
    content: ''
  },
  {
    title: 'Nuxt',
    content: 'SSRやBFFなどが必要なプロジェクトでは、ほとんどNuxtで書いています。'
  },
  {
    title: 'React',
    content: 'SPAが可能なプロジェクトでは、直近では、Hooks、 Redux Starter Kit, Redux Sagaを使用して書きます。デザイン面も要求される場合は、Material UIを使用します。'
  },
  {
    title: 'Next',
    content: 'Nuxtと比較すると不十分な面や関数ベースの機能に対応していないことなどもあるので、直近の新規プロジェクトではあまり使用しませんが、既存の改修や保守の際に触れることが多々あります。'
  },
  {
    title: 'Django',
    content: ''
  },
  {
    title: 'SpringBoot',
    content: ''
  },
];
